// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1167":"07ad5d6a","6825":"d0e57955"}[chunkId] + ".chunk.css";
};